import * as yup from 'yup';
import { PriceEstimateWithoutServicePlanPageFormData } from './PriceEstimateWithoutServicePlanPageFormData';

export const priceEstimateWithoutServicePlanPageFormSchema: yup.SchemaOf<PriceEstimateWithoutServicePlanPageFormData> = yup.object({
  termsAndConditionsAccepted: yup.boolean().label('Terms and conditions').required().isTrue(),
});
